import http from '@core/fetch'

export default {
  // 微信号绑定详情
  getWechatDetail: async () => {
    return http('/p/wedding/index.php/Admin/APIMerchantSupport/detail')
  },
  // 解绑微信
  unbindWechat: () => {
    return http.put('/hms/hljMerchantCenter/appApi/wxBiz/unbind/hljMerchant')
  },
  // 获取登陆二维码
  getWechatQRcode: () => {
    return http('/hms/hljMerchantCenter/appApi/wxBiz/bind/hljMerchant/qrcode')
  },
  // 获取通知二维码
  getWechatNotice: () => {
    return http(
      '/hms/hljMerchantCenter/appApi/wxBiz/qrcode/attention/hljMerchant'
    )
  },
  // 解绑微信通知
  unbindWechatNotice: () => {
    return http.put(
      '/hms/hljMerchantCenter/appApi/wxBiz/unbind/attention/hljMerchant'
    )
  },
  // 判断是否绑定微信号轮询+绑定
  checkWechatBindPolling: body =>
    http('/hms/hljMerchantCenter/appApi/wxBiz/bind/hljMerchant/status', {
      body
    }),
  // 绑定手机号
  bindPhone: body =>
    http.post('/hms/hljMerchantCenter/appApi/login/sms/bind', {
      body
    }),
  // 判断是否绑定微信号
  checkWechatBind: () =>
    http('/hms/hljMerchantCenter/appApi/wxBiz/bind/status/hljMerchant'),
  // 判断是否绑定微信号通知
  checkWechatBindNotice: () =>
    http(
      '/hms/hljMerchantCenter/appApi/wxBiz/bind/status/attention/hljMerchant'
    )
}
